// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "node_modules_vee-validate_node_modules_vue_devtools-api_dist_index_js") return "dist/js/admin/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};